import rtcEngine from '../main/rtc-engine'
import { promiseHandler } from '../common/promise-handler'
import { EventType } from "../common/enums"
import DetectRTC from 'detectrtc';

export function initPlatform(HstEngine) {
  /**
   * 初始化引擎
   * @params {*} params 
   */
  HstEngine.prototype.init = function(params) {
    rtcEngine.doInit(params);
    return promiseHandler(EventType.EVENT_INIT);
  };

  /**
   * 登录
   * @params {*} params 
   */
  HstEngine.prototype.login = function(params) {
    rtcEngine.doLogin(params);
    return promiseHandler(EventType.EVENT_LOGIN);
  };

  /**
   * 加入分组
   * @params {*} groupId 
   */
  HstEngine.prototype.joinGroup = function(groupId) {
    rtcEngine.doJoin(groupId);
    return promiseHandler(EventType.EVENT_JOIN_GROUP);
  };

  /**
   * 离开分组
   */
  HstEngine.prototype.leaveGroup = function() {
    rtcEngine.doLeave();
    return promiseHandler(EventType.EVENT_LEAVE_GROUP);
  };

  /**
   * 退出
   */
  HstEngine.prototype.logout = function() {
    rtcEngine.doLogout();
    return promiseHandler(EventType.EVENT_LOGOUT);
  };

  /**
   * 销毁引擎
   */
  HstEngine.prototype.destroy = function() {
    rtcEngine.doDestroy();
  }

  /**
   * 加入直播
   */
  HstEngine.prototype.isWebRTCSupported = function () {
    return DetectRTC.isWebRTCSupported
  }
}